import React from "react";
import Modal from "react-modal";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Dim the background
    transition: "background-color 0.3s ease-in-out", // Fade in/out
    zIndex: 100,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0",
    // width: "60vw",
    maxHight: "80vh",
    background: "transparent",
    border: "none",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    transition: "transform 0.3s ease-in-out", // Fade in/out
  },
};

Modal.setAppElement("#root");

type props = {
  isOpen: boolean;
  onRequestClose: () => void;
  children: any;
};

const CustomModal = (props: props) => {
  return (
    <div>
      <Modal
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
        style={customStyles}
      >
        {props.children}
      </Modal>
    </div>
  );
};

export default CustomModal;
